import { CircularProgress } from '@mui/material';
import { ISaveStatusProps } from './SaveStatus-types';
import { SubmitStatus } from '../App/App-types';
import './SaveStatus.scss';
import { Tooltip } from '@thought-river/ui-components';
import { CheckCircle, CloudDoneOutlined, CloudOff } from '@mui/icons-material';
import { getLastUpdatedText } from './SaveStatus-helpers';

const SavingLoader = (): JSX.Element => (
    <div className="save-status-loader" data-id="save-status-loader">
        <CircularProgress className="loader-icon" size={15} />
        <span className="loader-text">Saving...</span>
    </div>
);

const SaveStatus = (props: ISaveStatusProps): JSX.Element => {
    const { updatedAt, updatedBy, submitStatus } = props;

    if (submitStatus === SubmitStatus.PROCESSING) {
        return <SavingLoader />;
    }

    let statusText = 'All changes saved.';
    let tooltipLabel = <CloudDoneOutlined className="status-icon success" />;

    if (submitStatus === SubmitStatus.FAILURE) {
        statusText = 'Changes not saved.';
        tooltipLabel = <CloudOff className="status-icon error" />;
    }

    const renderIcon = (status: SubmitStatus): React.ReactNode => {
        const className = `status-icon ${status}`;

        switch (status) {
            case SubmitStatus.FAILURE:
                return <CloudOff className={className} />;
            case SubmitStatus.SUCCESS:
                return <CheckCircle className={className} />;
            default:
                return null;
        }
    };

    const statusTooltipContent = (
        <div className="status-tooltip-content" data-id="status-tooltip">
            <div
                className={`status-text ${
                    submitStatus === SubmitStatus.SUCCESS ? 'success' : 'error'
                }`}
            >
                {renderIcon(submitStatus)}
                {statusText}
            </div>
            {updatedAt && (
                <div className="last-updated-text">
                    {getLastUpdatedText(updatedAt, updatedBy)}
                </div>
            )}
        </div>
    );

    return (
        <Tooltip
            title={statusTooltipContent}
            placement="bottom-start"
            classes={{ tooltip: 'status-tooltip' }}
        >
            {tooltipLabel}
        </Tooltip>
    );
};

export default SaveStatus;
